import type { Role, User } from '@shared/types';

/**
 * Returns true if the given role is a platform-admin role
 * (`admin` or `super_admin`). Used to gate admin-only UI such as the
 * "Admin console" sidebar link. Mirrors `isAdminRole` in
 * `src/worker/middleware/auth.ts`; the route-level guard in `App.tsx`
 * uses a rank table to express the same intent.
 */
export function isAdminRole(role: Role | null | undefined): boolean {
  return role === 'admin' || role === 'super_admin';
}

/**
 * Convenience: accepts the whole `User` (or `null`) so callers don't have
 * to drill into `.role` themselves.
 */
export function isAdmin(user: User | null | undefined): boolean {
  return !!user && isAdminRole(user.role);
}
